module.exports = __webpack_public_path__ + "img/26t.0b280202.jpg";